import React from 'react';
import './styles.scss';

interface InfoItemProps {
  title: string;
  description: string;
  icon: React.ReactNode;
}

export const InfoItem = ({ description, title, icon }: InfoItemProps) => {
  return (
    <div className="info-item">
      <div className="info-item__head">
        {icon}
        <span className="info-item__head-title">{title}</span>
      </div>
      <span className="info-item__desc">{description}</span>
    </div>
  );
};
